(() => {
  'use strict';

  const rootElement =
    document.querySelector(
      '[data-sm-bundle]'
    );

  if (!rootElement) {
    return;
  }


  const configElement =
    document.getElementById(
      'SmartMakroFreeGiftConfig'
    );

  if (!configElement) {
    console.warn(
      'Smart Makro Bundle: gavekonfiguration mangler.'
    );

    return;
  }


  let giftConfig;

  try {

    giftConfig =
      JSON.parse(
        configElement.textContent
      );

  } catch (error) {

    console.error(
      'Smart Makro Bundle: gavekonfiguration kunne ikke læses.',
      error
    );

    return;

  }


  if (
    !Array.isArray(
      giftConfig.giftProducts
    ) ||
    !giftConfig.giftProducts.length
  ) {
    return;
  }


  const root =
    window.Shopify?.routes?.root ||
    '/';


  const bundleVariantId =
    Number(
      rootElement.dataset
        .bundleVariantId
    );


  const bundleTitle =
    rootElement.dataset
      .bundleTitle ||
    'Kickstart & Hold Fast';


  const bundlePrice =
    Number(
      rootElement.dataset
        .bundlePrice ||
      0
    );


  const bundlePriceLabel =
    bundlePrice > 0
      ? `${Math.round(bundlePrice / 100).toLocaleString('da-DK')} kr.`
      : '';


  const toggleButton =
    rootElement.querySelector(
      '[data-sm-bundle-toggle]'
    );


  const picker =
    rootElement.querySelector(
      '[data-sm-bundle-picker]'
    );


  const giftsContainer =
    rootElement.querySelector(
      '[data-sm-bundle-gifts]'
    );


  const variantsContainer =
    rootElement.querySelector(
      '[data-sm-bundle-variants]'
    );


  const addButton =
    rootElement.querySelector(
      '[data-sm-bundle-add]'
    );


  const laterButton =
    rootElement.querySelector(
      '[data-sm-bundle-later]'
    );


  const closeButton =
    rootElement.querySelector(
      '[data-sm-bundle-close]'
    );


  const errorNode =
    rootElement.querySelector(
      '[data-sm-bundle-error]'
    );


  const giftBenefitNode =
    rootElement.querySelector(
      '.sm-bundle-upgrade__gift-benefit'
    );


  const pickerEyebrow =
    picker.querySelector(
      '.sm-bundle-gift-picker__eyebrow'
    );


  const pickerTitle =
    picker.querySelector(
      '.sm-bundle-gift-picker__title'
    );


  const pickerText =
    picker.querySelector(
      '.sm-bundle-gift-picker__text'
    );


  const originalGiftBenefitText =
    giftBenefitNode?.textContent ||
    '🎁 Vælg også 1 af 4 gratis gaver';


  const originalPickerEyebrow =
    pickerEyebrow?.textContent ||
    'INKLUDERET MED BUNDLET';


  const originalPickerTitle =
    pickerTitle?.textContent ||
    'Vælg din gratis gave';


  const originalPickerText =
    pickerText?.textContent ||
    '';


  const state = {
    selectedGiftId: null,
    selectedChoice: null,
    loading: false,
    hasExistingGift: false
  };


  const esc =
    value =>
      String(
        value ?? ''
      )
        .replaceAll(
          '&',
          '&amp;'
        )
        .replaceAll(
          '<',
          '&lt;'
        )
        .replaceAll(
          '>',
          '&gt;'
        )
        .replaceAll(
          '"',
          '&quot;'
        )
        .replaceAll(
          "'",
          '&#039;'
        );


  const choicesFor =
    gift =>
      Array.isArray(
        gift?.choices
      )
        ? gift.choices
        : [];


  const availableChoices =
    gift =>
      choicesFor(
        gift
      )
        .filter(
          choice =>
            choice.available
        );


  const strictPhysicalChoice =
    gift => {

      const available =
        availableChoices(
          gift
        );


      const exact =
        available.find(
          choice => {

            const title =
              String(
                choice.title ||
                ''
              )
                .trim()
                .toLowerCase();


            const physical =
              title.includes(
                'fysisk'
              );


            const digital =
              title.includes(
                'e-bog'
              ) ||
              title.includes(
                'ebog'
              ) ||
              title.includes(
                'e bog'
              ) ||
              title.includes(
                'digital'
              ) ||
              title.includes(
                '+'
              );


            return (
              physical &&
              !digital
            );

          }
        );


      if (exact) {
        return exact;
      }


      if (
        available.length === 1
      ) {

        const title =
          String(
            available[0].title ||
            ''
          )
            .trim()
            .toLowerCase();


        if (
          !title.includes(
            'e-bog'
          ) &&
          !title.includes(
            'digital'
          ) &&
          !title.includes(
            '+'
          )
        ) {
          return available[0];
        }

      }


      return null;

    };


  const directChoiceFor =
    gift => {

      if (
        gift.physicalOnly
      ) {
        return strictPhysicalChoice(
          gift
        );
      }


      const available =
        availableChoices(
          gift
        );


      return (
        available.length === 1
          ? available[0]
          : null
      );

    };


  const showError =
    message => {

      errorNode.textContent =
        message;

      errorNode.hidden =
        false;

    };


  const clearError =
    () => {

      errorNode.textContent =
        '';

      errorNode.hidden =
        true;

    };


  const setLoading =
    loading => {

      state.loading =
        loading;


      rootElement.classList.toggle(
        'is-loading',
        loading
      );


      addButton.disabled =
        loading ||
        (
          !state.hasExistingGift &&
          !state.selectedChoice
        );


      laterButton.disabled =
        loading;


      if (
        loading
      ) {

        addButton.textContent =
          'Lægger i kurven…';

      } else {

        updateAddButton();

      }

    };


  const updateAddButton =
    () => {

      if (
        state.hasExistingGift
      ) {

        addButton.disabled =
          state.loading;

        addButton.textContent =
          bundlePriceLabel
            ? `Læg bundlet i kurven – ${bundlePriceLabel}`
            : 'Læg bundlet i kurven';

        return;

      }


      if (
        !state.selectedChoice
      ) {

        addButton.disabled =
          true;

        addButton.textContent =
          'Vælg en gratis gave';

        return;

      }


      addButton.disabled =
        false;

      addButton.textContent =
        bundlePriceLabel
          ? `Læg i kurven med gratis gave – ${bundlePriceLabel}`
          : 'Læg i kurven med gratis gave';

    };


  const cardImageFor =
    gift => {

      const available =
        availableChoices(
          gift
        );


      return (
        gift.image ||
        available[0]?.image ||
        ''
      );

    };


  const renderGiftCards =
    () => {

      giftsContainer.innerHTML =
        giftConfig.giftProducts
          .map(
            gift => {

              const selected =
                Number(
                  state.selectedGiftId
                ) ===
                Number(
                  gift.productId
                );


              const image =
                cardImageFor(
                  gift
                );


              return `
                <button
                  type="button"
                  class="sm-bundle-gift-card ${selected ? 'is-selected' : ''}"
                  data-sm-bundle-gift="${Number(gift.productId)}"
                >

                  <span class="sm-bundle-gift-card__image">

                    ${
                      image
                        ? `
                            <img
                              src="${esc(image)}"
                              alt=""
                              loading="lazy"
                            >
                          `
                        : ''
                    }

                    <span class="sm-bundle-gift-card__check">
                      ✓
                    </span>

                  </span>


                  <span class="sm-bundle-gift-card__title">
                    ${esc(gift.title)}
                  </span>


                  <span class="sm-bundle-gift-card__cta">
                    ${
                      selected
                        ? 'Valgt'
                        : (
                            directChoiceFor(gift)
                              ? 'Vælg gave'
                              : 'Vælg variant'
                          )
                    }
                  </span>

                </button>
              `;

            }
          )
          .join('');

    };


  const renderVariants =
    gift => {

      const choices =
        availableChoices(
          gift
        );


      if (
        gift.physicalOnly ||
        choices.length <= 1
      ) {

        variantsContainer.hidden =
          true;

        variantsContainer.innerHTML =
          '';

        return;

      }


      variantsContainer.hidden =
        false;


      variantsContainer.innerHTML = `
        <div class="sm-bundle-variant-panel">

          <div class="sm-bundle-variant-panel__title">
            Vælg variant af ${esc(gift.title)}
          </div>


          <div class="sm-bundle-variant-panel__grid">

            ${
              choices
                .map(
                  choice => {

                    const selected =
                      Number(
                        state.selectedChoice
                          ?.variantId
                      ) ===
                      Number(
                        choice.variantId
                      );


                    return `
                      <button
                        type="button"
                        class="sm-bundle-variant ${selected ? 'is-selected' : ''}"
                        data-sm-bundle-choice="${Number(choice.variantId)}"
                      >

                        ${
                          choice.image
                            ? `
                                <span class="sm-bundle-variant__image">

                                  <img
                                    src="${esc(choice.image)}"
                                    alt=""
                                    loading="lazy"
                                  >

                                </span>
                              `
                            : ''
                        }


                        <span class="sm-bundle-variant__title">
                          ${esc(choice.title)}
                        </span>


                        ${
                          selected
                            ? `
                                <span class="sm-bundle-variant__check">
                                  ✓
                                </span>
                              `
                            : ''
                        }

                      </button>
                    `;

                  }
                )
                .join('')
            }

          </div>

        </div>
      `;

    };


  const selectGift =
    gift => {

      clearError();


      state.selectedGiftId =
        Number(
          gift.productId
        );


      const direct =
        directChoiceFor(
          gift
        );


      if (
        direct
      ) {

        state.selectedChoice =
          direct;

        variantsContainer.hidden =
          true;

        variantsContainer.innerHTML =
          '';

      } else {

        state.selectedChoice =
          null;

        renderVariants(
          gift
        );

      }


      renderGiftCards();

      updateAddButton();

    };


  const selectChoice =
    choice => {

      clearError();


      state.selectedChoice =
        choice;


      const gift =
        giftConfig.giftProducts
          .find(
            item =>
              Number(
                item.productId
              ) ===
              Number(
                state.selectedGiftId
              )
          );


      renderGiftCards();


      if (
        gift
      ) {
        renderVariants(
          gift
        );
      }


      updateAddButton();

    };


  const fetchCart =
    async () => {

      const response =
        await fetch(
          `${root}cart.js`,
          {
            credentials:
              'same-origin',

            cache:
              'no-store',

            headers: {
              Accept:
                'application/json'
            }
          }
        );


      if (
        !response.ok
      ) {
        throw new Error(
          'Kurven kunne ikke hentes.'
        );
      }


      return response.json();

    };


  const isGiftLine =
    item =>
      String(
        item?.properties
          ?._smartmakro_free_gift ||
        ''
      ) ===
      'true';


  const existingGiftLine =
    cart =>
      (
        cart?.items ||
        []
      )
        .find(
          isGiftLine
        ) ||
      null;


  const applyExistingGiftUI =
    hasExistingGift => {

      state.hasExistingGift =
        Boolean(
          hasExistingGift
        );


      rootElement.classList.toggle(
        'has-existing-gift',
        state.hasExistingGift
      );


      if (
        giftBenefitNode
      ) {

        giftBenefitNode.textContent =
          state.hasExistingGift
            ? '✓ Gratis gave allerede valgt'
            : originalGiftBenefitText;

      }


      if (
        pickerEyebrow
      ) {

        pickerEyebrow.textContent =
          state.hasExistingGift
            ? 'GRATIS GAVE ALLEREDE VALGT'
            : originalPickerEyebrow;

      }


      if (
        pickerTitle
      ) {

        pickerTitle.textContent =
          state.hasExistingGift
            ? 'Din gave bliver i kurven'
            : originalPickerTitle;

      }


      if (
        pickerText
      ) {

        pickerText.textContent =
          state.hasExistingGift
            ? 'Du har allerede valgt din gratis gave. Bundlet kan lægges i kurven uden at ændre eller erstatte den.'
            : originalPickerText;

      }


      if (
        state.hasExistingGift
      ) {

        giftsContainer.hidden =
          true;

        variantsContainer.hidden =
          true;

        laterButton.hidden =
          true;

      } else {

        giftsContainer.hidden =
          false;

        laterButton.hidden =
          false;

        if (
          !state.selectedGiftId
        ) {

          variantsContainer.hidden =
            true;

          variantsContainer.innerHTML =
            '';

        }

      }


      updateAddButton();

    };


  const syncExistingGiftState =
    async () => {

      const cart =
        await fetchCart();


      const giftLine =
        existingGiftLine(
          cart
        );


      applyExistingGiftUI(
        Boolean(
          giftLine
        )
      );


      return giftLine;

    };


  const addItems =
    async items => {

      const response =
        await fetch(
          `${root}cart/add.js`,
          {
            method:
              'POST',

            credentials:
              'same-origin',

            headers: {
              'Content-Type':
                'application/json',

              Accept:
                'application/json'
            },

            body:
              JSON.stringify({
                items
              })
          }
        );


      const result =
        await response.json();


      if (
        !response.ok ||
        result.status
      ) {

        throw new Error(
          result.description ||
          result.message ||
          'Produkterne kunne ikke lægges i kurven.'
        );

      }


      return result;

    };


  const giftIsFree =
    (
      cart,
      variantId
    ) => {

      const matchingLines =
        (
          cart.items ||
          []
        )
          .filter(
            item =>
              Number(
                item.variant_id
              ) ===
              Number(
                variantId
              )
          );


      const giftLine =
        matchingLines.find(
          isGiftLine
        );


      if (!giftLine) {
        return false;
      }


      const unitPrice =
        Number(
          giftLine.original_price ??
          giftLine.price ??
          0
        );


      if (
        unitPrice <= 0
      ) {
        return true;
      }


      let totalDiscount =
        0;


      for (
        const item
        of matchingLines
      ) {

        const original =
          Number(
            item.original_line_price ??
            item.line_price ??
            0
          );


        const final =
          Number(
            item.final_line_price ??
            item.line_price ??
            original
          );


        totalDiscount +=
          Math.max(
            0,
            original - final
          );


        totalDiscount +=
          (
            item.line_level_discount_allocations ||
            []
          )
            .reduce(
              (
                sum,
                allocation
              ) =>
                sum +
                Number(
                  allocation.amount ||
                  0
                ),
              0
            );

      }


      return (
        totalDiscount >=
        unitPrice - 1
      );

    };


  const removeGiftOnly =
    async variantId => {

      const cart =
        await fetchCart();


      const updates =
        {};


      (
        cart.items ||
        []
      )
        .filter(
          item =>
            isGiftLine(
              item
            ) &&
            Number(
              item.variant_id
            ) ===
            Number(
              variantId
            )
        )
        .forEach(
          item => {

            updates[
              item.key
            ] = 0;

          }
        );


      if (
        !Object.keys(
          updates
        ).length
      ) {
        return;
      }


      await fetch(
        `${root}cart/update.js`,
        {
          method:
            'POST',

          credentials:
            'same-origin',

          headers: {
            'Content-Type':
              'application/json',

            Accept:
              'application/json'
          },

          body:
            JSON.stringify({
              updates
            })
        }
      );

    };


  const refreshAndOpenCart =
    () => {

      document.dispatchEvent(
        new CustomEvent(
          'cart:updated'
        )
      );


      window.setTimeout(
        () => {

          document.dispatchEvent(
            new CustomEvent(
              'cart:refresh',
              {
                detail: {
                  open: true
                }
              }
            )
          );

        },
        100
      );

    };


  const addBundleWithGift =
    async () => {

      if (
        state.loading
      ) {
        return;
      }


      try {

        setLoading(
          true
        );

        clearError();


        /*
         * Hvis kunden allerede har valgt en gratis gave,
         * må bundle-flowet aldrig fjerne eller erstatte den.
         */
        const cartBeforeAdd =
          await fetchCart();


        const existingGift =
          existingGiftLine(
            cartBeforeAdd
          );


        if (
          existingGift
        ) {

          applyExistingGiftUI(
            true
          );


          await addItems([
            {
              id:
                bundleVariantId,

              quantity:
                1
            }
          ]);


          refreshAndOpenCart();

          return;

        }


        applyExistingGiftUI(
          false
        );


        if (
          !state.selectedChoice
        ) {

          showError(
            'Vælg en gratis gave først.'
          );

          return;

        }


        const selectedGiftVariantId =
          Number(
            state.selectedChoice
              .variantId
          );


        await addItems([
          {
            id:
              bundleVariantId,

            quantity:
              1
          },

          {
            id:
              selectedGiftVariantId,

            quantity:
              1,

            properties: {
              _smartmakro_free_gift:
                'true'
            }
          }
        ]);


        const cart =
          await fetchCart();


        /*
         * Sikkerhed:
         * Den nye gave skal rent faktisk være gratis.
         * Kun den gavevariant, som dette flow lige har tilføjet,
         * må fjernes ved fejl.
         */
        if (
          !giftIsFree(
            cart,
            selectedGiftVariantId
          )
        ) {

          await removeGiftOnly(
            selectedGiftVariantId
          );


          showError(
            'Bundlet er lagt i kurven, men gaven blev ikke 0 kr. Vælg i stedet din gratis gave direkte i kurven.'
          );


          refreshAndOpenCart();

          return;

        }


        applyExistingGiftUI(
          true
        );


        refreshAndOpenCart();


      } catch (error) {

        console.error(
          'Smart Makro Bundle:',
          error
        );


        showError(
          error.message ||
          'Der opstod en fejl. Prøv igen.'
        );


      } finally {

        setLoading(
          false
        );

      }

    };


  const addBundleWithoutGift =
    async () => {

      if (
        state.loading
      ) {
        return;
      }


      try {

        setLoading(
          true
        );

        clearError();


        await addItems([
          {
            id:
              bundleVariantId,

            quantity:
              1
          }
        ]);


        refreshAndOpenCart();


      } catch (error) {

        console.error(
          'Smart Makro Bundle:',
          error
        );


        showError(
          error.message ||
          'Bundlet kunne ikke lægges i kurven.'
        );


      } finally {

        setLoading(
          false
        );

      }

    };


  const openPicker =
    async () => {

      try {

        await syncExistingGiftState();

      } catch (error) {

        console.warn(
          'Smart Makro Bundle: kunne ikke kontrollere eksisterende gave.',
          error
        );

      }


      picker.hidden =
        false;


      rootElement.classList.add(
        'is-open'
      );


      toggleButton.setAttribute(
        'aria-expanded',
        'true'
      );


      if (
        !state.hasExistingGift
      ) {

        renderGiftCards();

      }


      picker.scrollIntoView({
        behavior:
          'smooth',

        block:
          'nearest'
      });

    };


  const closePicker =
    () => {

      picker.hidden =
        true;


      rootElement.classList.remove(
        'is-open'
      );


      toggleButton.setAttribute(
        'aria-expanded',
        'false'
      );

    };


  toggleButton
    .addEventListener(
      'click',
      openPicker
    );


  closeButton
    .addEventListener(
      'click',
      closePicker
    );


  addButton
    .addEventListener(
      'click',
      addBundleWithGift
    );


  laterButton
    .addEventListener(
      'click',
      addBundleWithoutGift
    );


  giftsContainer
    .addEventListener(
      'click',
      event => {

        const button =
          event.target.closest(
            '[data-sm-bundle-gift]'
          );


        if (!button) {
          return;
        }


        const gift =
          giftConfig.giftProducts
            .find(
              item =>
                Number(
                  item.productId
                ) ===
                Number(
                  button.dataset
                    .smBundleGift
                )
            );


        if (!gift) {
          return;
        }


        selectGift(
          gift
        );

      }
    );


  variantsContainer
    .addEventListener(
      'click',
      event => {

        const button =
          event.target.closest(
            '[data-sm-bundle-choice]'
          );


        if (!button) {
          return;
        }


        const variantId =
          Number(
            button.dataset
              .smBundleChoice
          );


        const choice =
          giftConfig.giftProducts
            .flatMap(
              choicesFor
            )
            .find(
              item =>
                Number(
                  item.variantId
                ) ===
                variantId
            );


        if (!choice) {
          return;
        }


        selectChoice(
          choice
        );

      }
    );


  document.addEventListener(
    'cart:updated',
    () => {

      syncExistingGiftState()
        .catch(
          error =>
            console.warn(
              'Smart Makro Bundle: kunne ikke opdatere gavestatus.',
              error
            )
        );

    }
  );


  syncExistingGiftState()
    .catch(
      error =>
        console.warn(
          'Smart Makro Bundle: kunne ikke kontrollere gavestatus ved start.',
          error
        )
    )
    .finally(
      updateAddButton
    );

})();